enum StorageReportMode {
  Standard = 'standard',
  ExitDate = 'exitDate',
}

export const StorageReportModes: string[] = Object.values(StorageReportMode)

export default StorageReportMode
